import { useParams } from "react-router-dom";
import CompanyStats from "./CompanyStats";
import SponsoredRoles from "./SponsoredRoles";
import JobAlert from "./JobAlert";
import JobPosition from "./JobPosition";
import SimilarCompanies from "./SimilarCompanies";
import TopBlock from "./TopBlock";
import * as paths from "../../../constants/paths";
import { useDispatch, useSelector } from "react-redux";
import { fetchCompanyDetails } from "../../../states/actions/fetchCompanies";
import { useEffect, useState } from "react";
import { getSponsorTypeBadge } from "../../../helpers/helpers";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import { ToastContainer } from "react-toastify";
import { use } from "react";
import ReactPaginate from "react-paginate";
// {paths.SITE_BASE_URL + "/images/no-image.svg"}

const CompanyDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchCompanies.content);
  const isLoading = useSelector((state) => state.fetchCompanies.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading,
  );
  const [visibleJobs, setVisibleJobs] = useState(5);
  // console.log('data',data);

  const {
    jobs_page_content,
    company,
    jobs,
    totalJobs,
    meta_desc,
    site_settings,
  } = data;

  const [page, setPage] = useState(1);
  const limit = 5;

  useEffect(() => {
    dispatch(fetchCompanyDetails(id, page, limit));
  }, [id, page]);
  // useEffect(() => {
  //   dispatch(fetchCompanyDetails(id));
  // }, []);
  const companyData = {
    id: company?.id,
    name: company?.title,
    image: company?.image,
    // profileUrl: "/company/techcorp",
    sponsorType: getSponsorTypeBadge(company?.sponsor_type),
    verified: Number(company?.is_verified) === 1 ? true : false,
    // verified: true,
    description: company?.short_desc,
    location: company?.company_location,
    employees: company?.no_of_employees,
    founded: company?.founded_year,
    website: company?.company_website,
    totalJobs: totalJobs,
  };

  const initialPage = page - 1;
  const pageCount = Math.ceil(totalJobs / limit);
  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    setPage(newPage);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleLoadMore = () => {
    setVisibleJobs((prev) => prev + 5);
  };

  useDocumentTitle(data.page_title);

  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <section id="company_details">
            <TopBlock company={companyData} />
            <div className="contain">
              <div className="main_row">
                <div className="left_column">
                  <div className="all_positions">
                    <div className="top_head">
                      <div className="h4">
                        <img
                          src={
                            paths.SITE_BASE_URL + "/images/icon_briefcase.png"
                          }
                          alt=""
                        />
                        Open Positions ({totalJobs})
                      </div>
                      {/* <div className="btn_blk">
                        <button type="button">All Departments</button>
                        <button type="button">All Locations</button>
                      </div> */}
                    </div>
                    <div className="job_positions_wrapper">
                      {
                        jobs?.map((job) => (
                          <JobPosition
                            key={job?.id}
                            job={job}
                            companyData={companyData}
                            jobs_page_content={jobs_page_content}
                          />
                        ))
                        /* {jobs?.slice(0, visibleJobs).map((job) => (
                        <JobPosition
                          key={job?.id}
                          job={job}
                          companyData={companyData}
                          jobs_page_content={jobs_page_content}
                        />
                      ))} */
                      }
                    </div>
                    {pageCount > 1 && (
                      <ReactPaginate
                        forcePage={initialPage}
                        pageCount={pageCount}
                        onPageChange={handlePageChange}
                        breakLabel="..."
                        previousLabel=""
                        nextLabel=""
                        pageRangeDisplayed={4}
                        marginPagesDisplayed={1}
                        containerClassName="pagination"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        activeClassName="active"
                        previousClassName="prev_btn"
                        previousLinkClassName="page-link"
                        nextClassName="next_btn"
                        nextLinkClassName="page-link"
                        breakClassName=""
                        breakLinkClassName="break-link"
                        renderOnZeroPageCount={false}
                      />
                    )}
                    {/* {visibleJobs < jobs?.length && (
                      <div className="btn_blk justify-content-center">
                        <button
                          type="button"
                          className="site_btn blank"
                          onClick={handleLoadMore}
                        >
                          Load More Jobs
                        </button>
                      </div>
                    )} */}
                  </div>
                  <SponsoredRoles
                    companyName={company?.title}
                    totalJobs={totalJobs}
                  />
                </div>
                <div className="right_column">
                  <CompanyStats company={company} totalJobs={totalJobs} />
                  {/* <SimilarCompanies /> */}
                  <JobAlert />
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </>
  );
};

export default CompanyDetails;
